import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

import CartClass from './../../../../../../../js/classes/Cart'

const Promocode = ({ refetch, setLoading, cart }) => {
    const promocodeInput = useRef(null),
    handleSetPromocode = (e) => {
        e.preventDefault()

        const promocode = promocodeInput.current.value

        setLoading(true)

        CartClass.setCoupon(promocode, (err, res) => {
            if (err) {

            } else {
                refetch()
            }
        })

        return false
    },
    coupon = cart.coupons.length > 0 ? cart.coupons[0] : null

    return <div className="happy-cart__promocode">
        <div className="happy-cart__promocode-title">
            Промокод или штрихкод скидочной карты
        </div>
        <form action="" method="post" className="happy-cart__promocode-form" onSubmit={ handleSetPromocode }>
            <input type="text" className="input happy-cart__promocode-input" ref={ promocodeInput } placeholder="Промокод" defaultValue={ coupon } />
            <button className="button button_black happy-cart__promocode-submit">Применить</button>
        </form>
    </div>
}

export default Promocode